import React, { useMemo } from "react";

import { Flex, xcss } from "@atlaskit/primitives";

import {
    Injections,
    ProjectSvg
} from "../../onboarding-wizard/wizard/assets/project-svg";
import { BoardColumnsSvg } from "../../onboarding-wizard/wizard/assets/board-columns-svg";

const DEFAULT_COLUMNS = ["To Do", "In Progress", "Done"];

export interface RightHandSideCodingAgentChoiceProps {
    readonly projectName?: string;
}

/**
 * TWCG-1935: right-hand side of the coding-agent-choice screen.
 *
 * Mirrors the wizard wireframe by rendering the same Jira project
 * mock SVG used by `page-board-columns` so the modal feels
 * continuous across the onboarding flow.
 *
 * TODO (SPICE-1791): extend BoardColumnsSvg with agent avatar support
 * so selected agents appear on board cards.
 */
export const RightHandSideCodingAgentChoice: React.FC<
    RightHandSideCodingAgentChoiceProps
> = ({ projectName }) => {
    // TODO (SPICE-1791): add selectedAgents to deps when agent avatars are supported
    const injections: Injections = useMemo(
        () => ({
            svgBody: BoardColumnsSvg({
                columnNames: DEFAULT_COLUMNS
            })
        }),
        []
    );

    return (
        <Flex
            alignItems="center"
            justifyContent="center"
            xcss={containerStyles}
        >
            <ProjectSvg
                projectName={projectName ?? ""}
                activeView="board"
                injections={injections}
            />
        </Flex>
    );
};

const containerStyles = xcss({
    height: "100%",
    backgroundColor: "elevation.surface"
});
